import React from 'react';

import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {MULTIPLE_VALUES_SENTINEL} from 'samples/plate-maps/transfer-table/FillPlateTransferTableConstants';

interface FillPlateTransferMeasurementAmountProps {
  typedValue: TypedValue | null;
  isMultipleValues: boolean;
}

export default function FillPlateTransferTableMeasurementAmount({
  typedValue,
  isMultipleValues,
}: FillPlateTransferMeasurementAmountProps): JSX.Element | null {
  if (isMultipleValues) {
    return <div>{MULTIPLE_VALUES_SENTINEL}</div>;
  } else if (typedValue != null) {
    return <div>{formatTypedValue(typedValue)}</div>;
  }
  return null;
}
